import { useEffect } from "react";

const FIELD_SELECTOR =
  'input:not([type="hidden"]):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled]), button[type="submit"]:not([disabled])';

// Keyboard-first: Enter moves focus to the next field in the same
// form/dialog (Tally-style). Skips textareas (Enter = newline) and
// respects fields that already handled Enter (e.defaultPrevented).
export function useGlobalEnterNav() {
  useEffect(() => {
    const handler = (e) => {
      if (e.key !== "Enter" || e.defaultPrevented || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;
      const el = e.target;
      if (!el || el.tagName === "TEXTAREA" || el.tagName === "BUTTON") return;
      if (el.tagName !== "INPUT" && el.tagName !== "SELECT") return;
      if (el.type === "submit" || el.type === "button" || el.type === "checkbox" || el.type === "radio" || el.type === "file") return;
      if (el.closest("[data-enter-nav-skip]")) return;
      const scope = el.closest("form") || el.closest('[role="dialog"]') || el.closest("main") || document.body;
      const fields = Array.from(scope.querySelectorAll(FIELD_SELECTOR)).filter(
        (f) => f === el || (f.offsetWidth > 0 && f.offsetHeight > 0)
      );
      const idx = fields.indexOf(el);
      if (idx === -1) return;
      const next = fields[idx + 1];
      if (next && next.type !== "submit") {
        e.preventDefault();
        next.focus();
        if (next.tagName === "INPUT" && typeof next.select === "function") next.select();
      }
      // Last field before submit button: default behavior (form submit) is kept.
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);
}
